/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type DeleteDefectInput = {
    defectId: string;
};
export type InspectionPanelDeleteDefectMutationVariables = {
    input: DeleteDefectInput;
};
export type InspectionPanelDeleteDefectMutationResponse = {
    readonly deleteDefect: {
        readonly success: boolean;
        readonly deletedId: string;
    };
};
export type InspectionPanelDeleteDefectMutation = {
    readonly response: InspectionPanelDeleteDefectMutationResponse;
    readonly variables: InspectionPanelDeleteDefectMutationVariables;
};



/*
mutation InspectionPanelDeleteDefectMutation(
  $input: DeleteDefectInput!
) {
  deleteDefect(input: $input) {
    success
    deletedId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDefectPayload",
    "kind": "LinkedField",
    "name": "deleteDefect",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionPanelDeleteDefectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InspectionPanelDeleteDefectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bd6cd50e5896a9f013989eb19ac9cdc6",
    "id": null,
    "metadata": {},
    "name": "InspectionPanelDeleteDefectMutation",
    "operationKind": "mutation",
    "text": "mutation InspectionPanelDeleteDefectMutation(\n  $input: DeleteDefectInput!\n) {\n  deleteDefect(input: $input) {\n    success\n    deletedId\n  }\n}\n"
  }
};
})();
(node as any).hash = '50c34b0293101d1ba9322838aff7beeb';
export default node;
